import { UrlMatcher, UrlSegment } from "@angular/router";

export const SystemErrorMatcher: UrlMatcher = (segments: UrlSegment[]) => {
    return segments.length === 2 && segments[0].path === 'signatures' ? null : { consumed: segments };
  };
